/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetInspectionTemplateQueryResponse, GetInspectionTemplatePathParams, GetInspectionTemplate400, GetInspectionTemplate401, GetInspectionTemplate403, GetInspectionTemplate404, GetInspectionTemplate409, GetInspectionTemplate500 } from "../../types/equipmentController/GetInspectionTemplate.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getInspectionTemplate } from "../../client/equipmentController/getInspectionTemplate.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getInspectionTemplateQueryKey = (organizationId: GetInspectionTemplatePathParams["organizationId"] | undefined, equipmentId: GetInspectionTemplatePathParams["equipmentId"] | undefined) => [{ url: '/api/organizations/:organizationId/equipment/:equipmentId/inspection-template', params: {organizationId:organizationId,equipmentId:equipmentId} }] as const

export type GetInspectionTemplateQueryKey = ReturnType<typeof getInspectionTemplateQueryKey>

export function getInspectionTemplateQueryOptions(organizationId: GetInspectionTemplatePathParams["organizationId"] | undefined, equipmentId: GetInspectionTemplatePathParams["equipmentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getInspectionTemplateQueryKey(organizationId, equipmentId)
        return queryOptions<GetInspectionTemplateQueryResponse, ResponseErrorConfig<GetInspectionTemplate400 | GetInspectionTemplate401 | GetInspectionTemplate403 | GetInspectionTemplate404 | GetInspectionTemplate409 | GetInspectionTemplate500>, GetInspectionTemplateQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && equipmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getInspectionTemplate(organizationId!, equipmentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get inspection checklist template
 * {@link /api/organizations/:organizationId/equipment/:equipmentId/inspection-template}
 */
export function useGetInspectionTemplate<TData = GetInspectionTemplateQueryResponse, TQueryData = GetInspectionTemplateQueryResponse, TQueryKey extends QueryKey = GetInspectionTemplateQueryKey>(organizationId: GetInspectionTemplatePathParams["organizationId"] | undefined, equipmentId: GetInspectionTemplatePathParams["equipmentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetInspectionTemplateQueryResponse, ResponseErrorConfig<GetInspectionTemplate400 | GetInspectionTemplate401 | GetInspectionTemplate403 | GetInspectionTemplate404 | GetInspectionTemplate409 | GetInspectionTemplate500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getInspectionTemplateQueryKey(organizationId, equipmentId)
         

         const query = useQuery({
          ...getInspectionTemplateQueryOptions(organizationId, equipmentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetInspectionTemplate400 | GetInspectionTemplate401 | GetInspectionTemplate403 | GetInspectionTemplate404 | GetInspectionTemplate409 | GetInspectionTemplate500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}